import { string } from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './style.css';

const LoanItem = ({ icon, label, title, subtitle }) => (
  <div className={classNames(s.loanItem, 'col-12')}>
    <img src={icon} alt={label} />
    <div className={s.loanContent}>
      <h6>{label}</h6>
      <p>{title}</p>
      <p>{subtitle}</p>
    </div>
  </div>
);

LoanItem.propTypes = {
  icon: string.isRequired,
  label: string.isRequired,
  title: string.isRequired,
  subtitle: string.isRequired,
};

export default withStyles(s)(LoanItem);
